"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("../../../errors");
const chargeMethodRecords_autogenerated_1 = __importDefault(require("./generated/chargeMethodRecords.autogenerated"));
const adjustments_schema_1 = __importDefault(require("./schemas/adjustments.schema"));
class Adjustments {
    schema = adjustments_schema_1.default;
    validate(chargeMethod, jsonPath = '$') {
        const result = this.schema.validate(chargeMethod, {
            abortEarly: false,
            convert: false,
        });
        if (result.error) {
            const issues = [];
            result.error.details.forEach((issue) => {
                switch (issue.type) {
                    case 'any.only': {
                        issues.push(new errors_1.Errors.ValidationIssue('IChargeMethod', errors_1.Errors.ValidationErrorCode.invalidValue, issue.context?.key, issue.context?.value, jsonPath));
                        break;
                    }
                    case 'any.required': {
                        issues.push(new errors_1.Errors.ValidationIssue('IChargeMethod', errors_1.Errors.ValidationErrorCode.requiredValue, issue.context?.key, undefined, jsonPath));
                        break;
                    }
                    case 'object.base': {
                        issues.push(new errors_1.Errors.ValidationIssue('IChargeMethod', errors_1.Errors.ValidationErrorCode.invalidType, undefined, issue.context?.value, jsonPath));
                        break;
                    }
                    case 'boolean.base': {
                        issues.push(new errors_1.Errors.ValidationIssue('IChargeMethod', errors_1.Errors.ValidationErrorCode.invalidType, issue.context?.key, issue.context?.value, jsonPath));
                        break;
                    }
                }
            });
            return issues;
        }
    }
    requestNextValueSet(chargeMethod) {
        const jsonPath = '$';
        const parsedObject = chargeMethod;
        if (parsedObject.chargeType === undefined ||
            parsedObject.chargeType === '') {
            return Object.keys(chargeMethodRecords_autogenerated_1.default.adjustments);
        }
        const validChargeType = this.schema
            .extract(`chargeType`)
            .validate(parsedObject.chargeType);
        if (validChargeType.error) {
            const chargeTypeError = new errors_1.Errors.ValidationError();
            chargeTypeError.addIssue('IChargeMethod', errors_1.Errors.ValidationErrorCode.invalidValue, 'chargeType', validChargeType.error.details[0].context?.value, jsonPath);
            throw chargeTypeError;
        }
        const chargeType = parsedObject.chargeType;
        if (parsedObject.countingUnit === undefined ||
            parsedObject.countingUnit === '') {
            return Object.keys(chargeMethodRecords_autogenerated_1.default.adjustments[chargeType]);
        }
        const validCountingUnits = this.schema
            .extract(`countingUnit`)
            .validate(parsedObject.countingUnit);
        if (validCountingUnits.error) {
            const countingUnitError = new errors_1.Errors.ValidationError();
            countingUnitError.addIssue('IChargeMethod', errors_1.Errors.ValidationErrorCode.invalidValue, 'countingUnit', validCountingUnits.error.details[0].context?.value, jsonPath);
            throw countingUnitError;
        }
        const countingUnits = parsedObject.countingUnit;
        if (parsedObject.calculatedBy === undefined ||
            parsedObject.calculatedBy === '') {
            return chargeMethodRecords_autogenerated_1.default.adjustments[chargeType][countingUnits];
        }
        else {
            throw new errors_1.Errors.OperationError(errors_1.Errors.OperationErrorCode.Disallowed, 'requestNextValueSet');
        }
    }
}
exports.default = Adjustments;
